
<template>
  <div>
    <app-nav></app-nav>

    <div id="app" class="container">
      <!--<vue2-sidebar :links="links">-->
        <slideout-panel></slideout-panel>
        <router-view/>
      <!--</vue2-sidebar>-->
    </div>
  </div>
</template>

<script>
import store from '@/store';
import AppNav from '@/components/custom/Nav';

export default {
  name: 'App',
  components: {
    AppNav
  },
  beforeCreate() {
    if (!store.state.isLogged && this.$route.path.indexOf('login') === -1) {
      this.$router.push('/login');
    }
  }
};
</script>

<style>
#nprogress .bar {
  background: #29d;

  position: fixed;
  z-index: 1031;
  top: 0;
  left: 0;

  width: 100%;
  height: 4px;
}

.img {
  height: 75px;
  width: 75px;
}

#app {
  margin-top: 20px;
}

.vermelho {
  color: #F44336 !important;
}

.amarelo {
  color: #d98609 !important;
}

.verde {
  color: green !important;
}

.verdeProtocolo {
  color: #52af78 !important;
}

.vermelhoProtocolo {
  color: #EF9A9A !important;
}

.fundoverde {
  background: #0A923B !important;
}

.vbst-item > span > strong {
  margin-right: 0 !important;
}
.vbt-autcomplete-list {
  background: white;
}

.grafico {
  min-height: 300px;
}
</style>


<style lang="scss">
$theme-colors: (
  success: #014442,
  primary: #014442,
  warning: #d98609,
  info: #8E8623
);

$teal-500: #014442; // #0A923B
$red-a700: #d98609;

@import 'bootstrap-material-design/scss/bootstrap-material-design.scss';
</style>






// WEBPACK FOOTER //
// src/App.vue